import { Address } from 'src/api/address';
import { OrderItxDto, ShippingOptionsItxDto } from 'src/api/customer';
import { ErrorMessage } from 'src/model/error-message';
import { AppState } from '..';
import { StateUpdaterMap } from '../../manager/state-manager';
import { AddressAlertErrorData, CheckoutStage, initialCheckoutState } from '../partials/checkout.model';
import { NewExpedition } from 'src/pages/Cart/BasketUserLoged/CheckoutShipping/CheckoutShipping.utils';

export interface CheckoutActions {
    CHK_SET_LOADING: boolean;
    CHK_SET_EXPEDITIONS: Record<string, NewExpedition>;
    CHK_SET_EXP_SHIPPING_METHODS: any;
    CHK_SET_GROUPS: any;
    CHK_SET_SHIPPING_METHODS: ShippingOptionsItxDto[];
    CHK_SET_ADDRESSES: Address[];
    CHK_SET_ADDRESS_ALERT_ERROR: AddressAlertErrorData;
    CHK_SET_SHIPPING_METHOD: ShippingOptionsItxDto;
    CHK_SET_SHIPPING_ADDRESS: Address;
    CHK_SET_ORDER: OrderItxDto;
    CHK_SET_STAGE: CheckoutStage;
    CHK_SET_COMPLETED_STAGE: CheckoutStage;
    CHK_SET_ERROR: ErrorMessage;
    CHK_DISMISS_ERROR: undefined;
    CNF_SET_LOADING: boolean;
    CNF_SET_ORDER: OrderItxDto;
    CNF_SET_ERROR: ErrorMessage;
    CHK_RESET: undefined;
    CHK_SET_BILLING_ADDRESS: Address;
}


export const checkoutActions: StateUpdaterMap<AppState, CheckoutActions> = {
    CHK_SET_LOADING: (loading, { checkout }) => ({
        checkout: {
            ...checkout,
            loading,
            error: loading ? null : checkout.error
        }
    }),
    CHK_SET_GROUPS: (groups, { checkout }) => ({
        checkout: {
            ...checkout,
            groups,
            error: null
        }
    }),

    CHK_SET_EXPEDITIONS:(expeditions, {checkout}) => ({
        checkout: {
            ...checkout,
            expeditions: expeditions ?? null,
            error: null
        }
   
    }),
    CHK_SET_EXP_SHIPPING_METHODS:(expShippingMethods, {checkout}) => ({
        checkout: {
            ...checkout,
            expeditionShippingMethods: expShippingMethods ?? null,
            error: null
        }
    }),
    CHK_SET_SHIPPING_METHODS: (shippingMethods, { checkout }) => {
        const shippingMethod = shippingMethods.find(method => method.id === checkout.shippingMethod?.id) ?? null;
        const shippingAddress = checkout.shippingMethod?.id === shippingMethod?.id 
            ? checkout.shippingAddress
            : null
        return {
            checkout: {
                ...checkout,
                shippingMethods,
                shippingMethod: shippingMethod,
                shippingAddress: shippingAddress,
                error: null
            }
        }
    },
    CHK_SET_ADDRESSES: (addresses, { checkout }) => ({
        checkout: {
            ...checkout,
            addresses,
            shippingAddress: addresses.find(addr => checkout.shippingAddress?.id === addr.id) ?? null,
            error: null
        }
    }),
    CHK_SET_ADDRESS_ALERT_ERROR: (addressAlertError, { checkout }) => {
        const errorData = typeof addressAlertError === 'string' 
            ? { type: addressAlertError } 
            : addressAlertError;
            
        return {
            checkout: {
                ...checkout,
                addressAlertError: errorData,
                error: null
            }
        };
    },
    CHK_SET_SHIPPING_METHOD: (method, { checkout }) => ({
        checkout: {
            ...checkout,
            shippingMethod: checkout.shippingMethods.find(sm => sm.id === method.id) ?? null,
            shippingAddress: checkout.shippingMethod?.id === method?.id ? checkout.shippingAddress : null,
            error: null
        }
    }),
    CHK_SET_SHIPPING_ADDRESS: (address, { checkout }) => ({
        checkout: {
            ...checkout,
            shippingAddress: (checkout?.shippingMethod && checkout?.addresses.find(addr => addr?.id === address?.id)) ?? null,
            error: null
        }
    }),
    CHK_SET_BILLING_ADDRESS: (address, { checkout }) => ({
         checkout: {
            ...checkout,
            billingAddress: address,
            error: null
        }}),
    CHK_SET_ORDER: (order, { checkout }) => ({
        checkout: {
            ...checkout,
            order,
            error: null
        }
    }),
    CHK_SET_STAGE: (stage, { checkout }) => ({
        checkout: {
            ...checkout,
            stage
        }
    }),
    CHK_SET_COMPLETED_STAGE: (completedStage, { checkout }) => ({
        checkout: {
            ...checkout,
            completedStage,
            error: null
        }
    }),
    CHK_SET_ERROR: (error, { checkout }) => ({
        checkout: {
            ...checkout,
            error,
            loading: false
        }
    }),
    CHK_DISMISS_ERROR: (_, { checkout }) => ({
        checkout: {
            ...checkout,
            error: null
        }
    }),
    CHK_RESET: (_, prevState) => ({
        cart: {
            ...prevState.cart,
            content: null,
            hasChangedItems: false,
            hasUnavailableItems: false,
            update: null,
            productCheck: null
        },
        checkout: initialCheckoutState
    }),
    CNF_SET_LOADING: (loading, _) => ({
        orderConfirmation: {
            order: null,
            loading,
            error: null
        }
    }),
    CNF_SET_ORDER: (order, _) => ({
        orderConfirmation: {
            order,
            error: null,
            loading: false
        }
    }),
    CNF_SET_ERROR: (error, _) => ({
        orderConfirmation: {
            error,
            loading: false,
            order: null
        }
    }),
};